module.exports = __webpack_public_path__ + "img/icon_white_HDTV.fde97aba.svg";